<template>
  <div class="wise-container">
    <h2>Wise</h2>
    <el-card>
      <div>Contenido de la vista Wise</div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'BotWise'
}
</script>

<style lang="scss" scoped>
.wise-container {
  padding: 20px;
}
</style> 